var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.9187,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#E5F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 47.075C56.7235 47.075 51.2395 52.0872 51.2395 57.7937V60.3682C51.407 60.354 51.5785 60.3458 51.75 60.3458H57.875C58.2811 60.3458 58.6706 60.5071 58.9577 60.7943C59.2449 61.0814 59.4062 61.4709 59.4062 61.877V76.1687C59.4062 76.5748 59.2449 76.9643 58.9577 77.2515C58.6706 77.5386 58.2811 77.7 57.875 77.7H51.75C50.2609 77.7 48.8328 77.1084 47.7798 76.0555C46.7269 75.0025 46.1354 73.5744 46.1354 72.0854V65.9604C46.1354 64.2168 46.9316 62.659 48.177 61.63V57.7937C48.177 49.97 55.4903 44.0125 64 44.0125C72.5096 44.0125 79.8229 49.97 79.8229 57.7937V61.63C81.0683 62.659 81.8645 64.2168 81.8645 65.9604V72.0854C81.8645 73.5744 81.273 75.0025 80.2201 76.0555C79.1671 77.1084 77.739 77.7 76.25 77.7H70.125C69.7188 77.7 69.3294 77.5386 69.0422 77.2515C68.755 76.9643 68.5937 76.5748 68.5937 76.1687V61.877C68.5937 61.4709 68.755 61.0814 69.0422 60.7943C69.3294 60.5071 69.7188 60.3458 70.125 60.3458H76.25C76.4215 60.3458 76.593 60.354 76.7604 60.3682V57.7937C76.7604 52.0872 71.2765 47.075 64 47.075ZM51.75 63.4083C50.3412 63.4083 49.1979 64.5516 49.1979 65.9604V72.0854C49.1979 73.4941 50.3412 74.6375 51.75 74.6375H56.3437V63.4083H51.75ZM78.802 65.9604C78.802 64.5516 77.6587 63.4083 76.25 63.4083H71.6562V74.6375H76.25C77.6587 74.6375 78.802 73.4941 78.802 72.0854V65.9604Z",
    fill: "#004577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventCall);
export default __webpack_public_path__ + "static/media/canvas_event_call.20d19068878c7ebde8513db1d16f33d5.svg";
export { ForwardRef as ReactComponent };